import { render, staticRenderFns } from "./WordCardTeaser.vue?vue&type=template&id=7fb65db5&scoped=true&"
import script from "./WordCardTeaser.vue?vue&type=script&lang=js&"
export * from "./WordCardTeaser.vue?vue&type=script&lang=js&"
import style0 from "./WordCardTeaser.vue?vue&type=style&index=0&id=7fb65db5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb65db5",
  null
  
)

export default component.exports